import { SafeIndexComponent } from './components/safe/safe-index/safe-index.component';
import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { ServiceIndexComponent } from './components/services/service-index/service-index.component';
import { AccountComponent } from './account.component';
import { AcademicYearIndexComponent } from './components/academic-year-index/academic-year-index.component';
import { StoreIndexComponent } from './components/store/store-index/store-index.component';
import { OldBalanceComponent } from './components/old-balance/old-balance.component';
import { PaymentDetailsReportComponent } from './components/report/payment-details-report/payment-details-report.component';
import { DiscountTypeIndexComponent } from './components/discountType/discount-type-index/discount-type-index.component';
import { StudentDetailsReportComponent } from './components/report/student-details-report/student-details-report.component';
import { StudentBalanceReportComponent } from './components/report/student-balance-report/student-balance-report.component';
import { ReportCreatorReportComponent } from './components/report/report-creator-report/report-creator-report.component';
import { InstallmentReportComponent } from './components/report/installment-report/installment-report.component';
import { StudentDiscountReportComponent } from './components/report/student-discount-report/student-discount-report.component';
import { Auth } from '../shared/auth';
import { AuthGuestService } from '../shared/middlewares/auth-guest.service';
import { TreeIndexComponent } from './components/tree/tree-index/tree-index.component';
import { BankIndexComponent } from './components/bank/bank-index/bank-index.component';
import { CompanyIndexComponent } from './components/company/company-index/company-index.component';
import { CheckIndexComponent } from './components/check/check-index/check-index.component';
import { DailyIndexComponent } from './components/daily/daily-index/daily-index.component';
import { TransformationIndexComponent } from './components/transformation/transformation-index/transformation-index.component';
import { WorksheetIndexComponent } from './components/worksheet/worksheet-index/worksheet-index.component';
import { ExpenseSheetComponent } from './components/worksheet/expense-sheet/expense-sheet.component';
import { DailySheetComponent } from './components/worksheet/daily-sheet/daily-sheet.component';
import { IncomeSheetComponent } from './components/worksheet/income-sheet/income-sheet.component';
import { DepositeSheetComponent } from './components/worksheet/deposite-sheet/deposite-sheet.component';
import { BalanceSheetComponent } from './components/worksheet/balance-sheet/balance-sheet.component';
import { SolfaSheetComponent } from './components/worksheet/solfa-sheet/solfa-sheet.component';
import { BankBalanceSheetComponent } from './components/worksheet/bank-balance-sheet/bank-balance-sheet.component';
import { CustodySheetComponent } from './components/worksheet/custody-sheet/custody-sheet.component';
import { CheckSheetComponent } from './components/worksheet/check-sheet/check-sheet.component';
import { InstallmentReport2Component } from './components/report/installment-report2/installment-report2.component';
import { PersonIndexComponent } from './components/persons/person-index/person-index.component';
import { WorksheetPrivateComponent } from './components/worksheet-private/worksheet-private.component';
import { WorkPrivateCheckComponent } from './components/work-private-check/work-private-check.component';
import { WorkPrivateDepositesComponent } from './components/work-private-deposites/work-private-deposites.component';
import { WorkPrivateBankComponent } from './components/work-private-bank/work-private-bank.component';
import { ServiceaffComponent } from './components/serviceaff/serviceaff.component';
import { NotiftransformComponent } from './components/notiftransform/notiftransform.component';
import { PaymentSummerComponent } from './components/payment-summer/payment-summer.component';


const routes: Routes = [
  {
    path: 'safe',
    component: SafeIndexComponent
  },
  {
    path: 'safe/:id',
    component: SafeIndexComponent
  },
  {
    path: 'report/payment-details',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('payment_detail_report')},
    component: PaymentDetailsReportComponent
  },
  {
    path: 'report/student-details',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('student_detail_report')},
    component: StudentDetailsReportComponent
  },
  {
    path: 'report/student-balances',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('account_setting')},
    component: StudentBalanceReportComponent
  },
  {
    path: 'report/summer-payment',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('account_setting')},
    component: PaymentSummerComponent
  },
  {
    path: 'report/report-creator',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('report_creator_report')},
    component: ReportCreatorReportComponent
  },
  {
    path: 'report/student-installment',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('installment_report')},
    component: InstallmentReportComponent
  },

  {
    path: 'report/student-installment2',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('installment_report')},
    component: InstallmentReport2Component
  },
  {
    path: 'report/student-discount',
    canActivate: [AuthGuestService],
    data: {can: Auth.can('student_discount_report')},
    component: StudentDiscountReportComponent
  },

  {
    path: "setting",
    component: AccountComponent,
    children: [
      {
        path: 's',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('account_setting')},
        component: OldBalanceComponent
      },
      {
        path: 'services',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('service_read')},
        component: ServiceIndexComponent
      },
      {
        path: 'stores',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('safe_read')},
        component: StoreIndexComponent
      },
      {
        path: 'discount_types',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('discount_type_read')},
        component: DiscountTypeIndexComponent
      },
      {
        path: 'academic_year_expenses',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('academic_expense_read')},
        component: AcademicYearIndexComponent
      },
      {
        path: 'trees',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('tree_read')},
        component: TreeIndexComponent
      },
      {
        path: 'banks',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('bank_read')},
        component: BankIndexComponent
      },
      {
        path: 'company',
        component: CompanyIndexComponent,
        canActivate: [AuthGuestService],
        data: {can: Auth.can('company')},

      },
      {
        path: 'serviceaff',
        component: ServiceaffComponent,
        canActivate: [AuthGuestService],
        data: {can: Auth.can('service')},

      },

      {
        path: 'person',
        component: PersonIndexComponent,
        // canActivate: [AuthGuestService],
        // data: {can: Auth.can('person')},

      },
      {
        path: 'worksheet_private',
        component: WorksheetPrivateComponent,
        // canActivate: [AuthGuestService],
        // data: {can: Auth.can('tmwel')},

      },
      {
        path: 'checks',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('check_read')},
        component: CheckIndexComponent
      },
      {
        path: 'dailys',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('daily_read')},
        component: DailyIndexComponent
      },
      {
        path: 'transformations',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('transformation_read')},
        component: TransformationIndexComponent
      },
      {
        path: 'notiftransform',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('transformation_read')},
        component: NotiftransformComponent
      },

      {
        path: "worksheet",
        component: WorksheetIndexComponent,
        children: [
          {
            path: 'expenses',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('tree_read')},
            component: ExpenseSheetComponent
          },
          {
            path: 'daily',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('expense_detail_read')},
            component: DailySheetComponent
          },
          {
            path: 'incomes',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('income_read')},
            component: IncomeSheetComponent
          },
          {
            path: 'custody',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('custody_read')},
            component: CustodySheetComponent
          },
          {
            path: 'transformations',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('deposite_read')},
            component: DepositeSheetComponent
          },
          {
            path: 'check',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('check_read')},
            component: CheckSheetComponent
          },
          {
            path: 'balances',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('store_balance_read')},
            component: BalanceSheetComponent
          },
          {
            path: 'bank-balances',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('bank_balance_read')},
            component: BankBalanceSheetComponent
          },
          {
            path: 'solfa',
            canActivate: [AuthGuestService],
            data: {can: Auth.can('solfa_read')},
            component: SolfaSheetComponent
          }

        ]
      },
      {
        path: 'check_private',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('check_read')},
        component: WorkPrivateCheckComponent
      },
      {
        path: 'deposite_private',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('check_read')},
        component: WorkPrivateDepositesComponent
      },
      {
        path: 'bank_private',
        canActivate: [AuthGuestService],
        data: {can: Auth.can('check_read')},
        component: WorkPrivateBankComponent
      },
    ]
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AccountRoutingModule {
}
